import React, { useState, useEffect } from "react";
import "./contact.scss";
  

const Branches = () => {
   

  return (
    <section className="ftco-section bg-light" id="contact">
      <div className="container">
        <h1 className="heading text-center mb-5">Our Branches</h1>
        <div className="row justify-content-left mb-5">
          <div className="col-md-12">
            <div className="row p-4 no-gutters">
              <div className="col-md-6 p-0">
                <h4 className='mb-4'>Chennai Office</h4>
                <p>No.1/109 Valeeswaran Koil Street, <br />Sriram Garden, Manapakkam, <br />Chennai - 600 125</p>

              </div>
              <div className="col-md-6 p-0">
                <h4 className='mb-4'>Theni Office</h4>
                <p>No: 12/2A/31W, L F Road, Gandhi nagar, <br />Mandhiyamman kovil, Cumbum<br />Theni District, Tamil Nadu 625516, India</p>

              </div></div>
            <div className="row p-4 no-gutters">
              <div className="col-md-6 p-0">
                <h4 className='mb-4'>Hyderabad & Secundrabad address</h4>
                <p>Dinakar Nagar, West Venkatapuram,  <br />Last Busstop,Near VB Mart, <br />Alwal, Secunderabad-500 010, India</p>

              </div>
              <div className="col-md-6 p-0">
                <h4 className='mb-4'>Mumbai address</h4>
                <p>Samar Apartment, Ground Floor, Room No. 7<br />Near AFC Gym, Anand Koliwada, <br />Thane District, Mumbra-400 612, India</p>

              </div>
            </div>
          </div>
        </div>
       
      </div>
    </section>
  );
};

export default Branches;
